import { STATIC_BLOG_POSTS } from "../lib/blog";

export function useBlogPost(id: string | undefined) {
  return {
    post: STATIC_BLOG_POSTS.find((post) => post.id === id),
    isLoading: false,
    error: null,
  };
}
